<template>
  <v-card class="mb-4" variant="flat">
    <v-tabs v-model="activeTab" color="primary" density="compact">
      <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value">
        <span>{{ tab.label }}</span>
        <v-chip
          v-if="'count' in tab"
          class="ml-2"
          density="compact"
          size="small"
          variant="tonal">
          {{ tab.count }}
        </v-chip>
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script lang="ts">
import { useContractorStore } from '@/pages/contractor/single/contractor'

export default {
  name: 'ContractorTabs',
  setup() {
    return useContractorStore()
  },
}
</script>
